import { i18n } from "@/i18n";
import { SIDENAV_GROUP_BY } from "@/constants";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

export const MSP_NAV_ITEMS = [
  {
    order: 5,
    groupBy: SIDENAV_GROUP_BY.GAMMA,
    label: i18n.global.t("sidebar-license-usage"),
    icon: "cb-icon-license",
    id: buildOrgUrl("msp", null, "license_usage"),
    dataTestId: "msp-license-usage",
  },
];

export const CUSTOMER_NAV_ITEMS = [
  {
    order: 5,
    groupBy: SIDENAV_GROUP_BY.GAMMA,
    label: i18n.global.t("sidebar-license-usage"),
    icon: "cb-icon-license",
    id: buildOrgUrl("customer", null, "license_usage"),
    dataTestId: "customer-license-usage",
  },
];

export default {};
